









import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name:'CommonProgress'
})
export default class CommonProgress  extends Vue {
  @Prop({default:0}) percent!:number
  @Prop({default:''}) speed!:string
}
